import React, { useState, useEffect } from 'react';
import { Container, Form, Row, Col } from 'react-bootstrap';

const cisi_questions = [
    {
        name: "motor",
        title: "1. Motor signs",
        options: [
            [0, "Normal"],
            [1, "Very mild"],
            [2, "Mild"],
            [3, "Mild to moderate"],
            [4, "Moderate"],
            [5, "Severe"],
            [6, "Very severe"]
        ]
    },
    {
        name: "disability",
        title: "2. Disability",
        options: [
            [0, "Normal"],
            [1, "Minimal slowness and/or clumsiness"],
            [2, "Slowness and/or clumsiness; no limitations"],
            [3, "Limitation for demanding activities; does not need help for basic ADL"],
            [4, "Limitation to perform basic ADL; help is required for some basic ADL"],
            [5, "Great limitation to perform basic ADL; help is required for most or all basic ADL"],
            [6, "Severely disabled; helpless; complete assistance needed"]
        ]
    },
    {
        name: "complications",
        title: "3. Motor complications (dyskinesia and fluctuations)",
        options: [
            [0, "Not at all"],
            [1, "Very mild"],
            [2, "Mild"],
            [3, "Mild to moderate"],
            [4, "Moderate"],
            [5, "Severe"],
            [6, "Very severe"]
        ]
    },
    {
        name: "cognition",
        title: "4. Cognitive status",
        options: [
            [0, "Normal"],
            [1, "Slowness and/or minimal cognitive problems"],
            [2, "Mild cognitive problems; no limitations"],
            [3, "Mild to moderate cognitive problems; does not need help for basic ADL"],
            [4, "Moderate cognitive problems; help is required for some basic ADL"],
            [5, "Severe cognitive problems; help is required for most or all basic ADL"],
            [6, "Severely disabled; helpless; complete assistance needed"]
        ]
    }
];

function CISI(props) {
    const [cisiState, setCisiState] = useState(() => {
        if (props.data) {
            // Editing existing data - use all data from DB as-is

            return { ...props.data };
        } else {
            // New data - initialize empty
            const initial = { totalScore: 0 };
            cisi_questions.forEach(q => { initial[q.name] = null; });
            return initial;
        }
    });

    useEffect(() => {
        if (props.handler) {
            props.handler('cisi', cisiState);
        }
    }, [cisiState]);

    const handleChange = (field, value) => {
        setCisiState(prev => {
            const updated = {
                ...prev,
                [field]: Number(value)
            };

            // Always recalculate totalScore when user makes changes
            updated.totalScore = cisi_questions.reduce((sum, q) => {
                const v = updated[q.name];
                const numValue = Number(v);
                return sum + (!isNaN(numValue) ? numValue : 0);
            }, 0);

            return updated;
        });
    };

    return (
        <Container>
            <h5>CISI-PD: Clinical Impression of Severity Index</h5>
            <Form>
                {cisi_questions.map(({ name, title, options }) => (
                    <Form.Group as={Row} className="mb-3" key={name}>
                        <Form.Label column sm={4}>{title}</Form.Label>
                        <Col sm={6}>
                            <Form.Control
                                as="select"
                                value={cisiState[name] ?? ''}
                                onChange={e => handleChange(name, e.target.value)}
                                disabled={props.disabled}
                            >
                                <option value="" disabled>Select score</option>
                                {options.map(([val, text]) => (
                                    <option key={val} value={val}>{val} – {text}</option>
                                ))}
                            </Form.Control>
                        </Col>
                    </Form.Group>
                ))}
            </Form>

            <div className="mt-3">
                <strong>Overall Severity Score:</strong> {cisiState.totalScore ?? 0} / 24
            </div>
        </Container>
    );
}

export default CISI;